import { z } from 'zod';
import { URLOrHashSchema } from './primitives';
import { PostSchema } from './post';

const OutletSchema = z.object({
  name: z.string(),
  note: z.string(),
  href: URLOrHashSchema,
});

// Curated cross-publication posts (Blockworks, HackerNoon, etc.).
// Stored without a `source` field; we default it to "manual" at use.
const ExternalPostInputSchema = PostSchema.omit({ source: true });

export const PublicationsSchema = z.object({
  outlets: z.array(OutletSchema).min(1),
  /** Posts published on other platforms (op-eds, interviews, guest essays). */
  externalPosts: z.array(ExternalPostInputSchema).min(1),
});

export type Outlet = z.infer<typeof OutletSchema>;
export type Publications = z.infer<typeof PublicationsSchema>;
